export default __webpack_public_path__ + "static/media/40t.38e44cf9.jpg";